module.exports = __webpack_public_path__ + "img/social-media-color-blocks-nissan.ea03cda1.png";